import React, { useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../services/firebase';
import { infoPageStyles as styles } from './sharedStyles';
import { COLORS } from '../../constants';

const ContactUs = () => {
  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    try {
      // Call Firebase Function to send message directly
      const submitContactForm = httpsCallable(functions, 'submitContactForm');
      const result = await submitContactForm({
        name: formData.name,
        email: formData.email,
        subject: formData.subject,
        message: formData.message,
      });
      
      if (result.data.success) {
        setSubmitted(true);
        setFormData({ name: '', email: '', subject: '', message: '' });
        
        setTimeout(() => {
          setSubmitted(false);
        }, 5000);
      }
    } catch (err) {
      setError(err.message || 'Failed to send message. Please try again or email us directly at redbirdmarket.isu@gmail.com');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.pageContainer}>
      <div style={styles.header}>
        <h1 style={styles.headerTitle}>Contact Us</h1>
        <p style={styles.headerSubtitle}>We're here to help</p>
      </div>

      <div style={styles.contentContainer}>
        {/* Contact Options */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Get in Touch</h2>
          <p style={styles.text}>
            Have questions or need support? Reach out to us through any of the following methods:
          </p>
        </div>

        <div style={styles.section}>
          <h3 style={styles.subsectionTitle}>📧 Email</h3>
          <p style={styles.text}>
            <a href="mailto:redbirdmarket.isu@gmail.com" style={styles.link}>redbirdmarket.isu@gmail.com</a>
          </p>
          <p style={{...styles.text, fontSize: '14px', color: COLORS.text.secondary}}>
            We typically respond within 24-48 hours
          </p>
        </div>

        {/* Contact Form */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Send Us a Message</h2>
          
          {submitted && (
            <div style={{...styles.highlight, background: '#4CAF5015', borderColor: '#4CAF50'}}>
              <p style={{...styles.text, color: '#4CAF50', margin: 0}}>
                ✓ Your message has been sent successfully! We'll respond within 24-48 hours.
              </p>
            </div>
          )}
          
          {error && (
            <div style={{...styles.highlight, background: '#f4433615', borderColor: '#f44336'}}>
              <p style={{...styles.text, color: '#f44336', margin: 0}}>
                {error}
              </p>
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{marginBottom: '16px'}}>
              <label style={{display: 'block', marginBottom: '8px', fontWeight: 600, color: COLORS.primary}}>Name</label>
              <input
                type="text"
                required
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                disabled={loading}
                style={{
                  width: '100%',
                  padding: '12px',
                  border: `2px solid ${COLORS.lightGray}`,
                  borderRadius: '8px',
                  fontSize: '16px',
                  boxSizing: 'border-box',
                  opacity: loading ? 0.6 : 1,
                }}
              />
            </div>

            <div style={{marginBottom: '16px'}}>
              <label style={{display: 'block', marginBottom: '8px', fontWeight: 600, color: COLORS.primary}}>Email</label>
              <input
                type="email"
                required
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                disabled={loading}
                style={{
                  width: '100%',
                  padding: '12px',
                  border: `2px solid ${COLORS.lightGray}`,
                  borderRadius: '8px',
                  fontSize: '16px',
                  boxSizing: 'border-box',
                  opacity: loading ? 0.6 : 1,
                }}
              />
            </div>

            <div style={{marginBottom: '16px'}}>
              <label style={{display: 'block', marginBottom: '8px', fontWeight: 600, color: COLORS.primary}}>Subject</label>
              <input
                type="text"
                required
                value={formData.subject}
                onChange={(e) => setFormData({...formData, subject: e.target.value})}
                disabled={loading}
                style={{
                  width: '100%',
                  padding: '12px',
                  border: `2px solid ${COLORS.lightGray}`,
                  borderRadius: '8px',
                  fontSize: '16px',
                  boxSizing: 'border-box',
                  opacity: loading ? 0.6 : 1,
                }}
              />
            </div>

            <div style={{marginBottom: '24px'}}>
              <label style={{display: 'block', marginBottom: '8px', fontWeight: 600, color: COLORS.primary}}>Message</label>
              <textarea
                required
                value={formData.message}
                onChange={(e) => setFormData({...formData, message: e.target.value})}
                rows={6}
                disabled={loading}
                style={{
                  width: '100%',
                  padding: '12px',
                  border: `2px solid ${COLORS.lightGray}`,
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontFamily: 'inherit',
                  resize: 'vertical',
                  boxSizing: 'border-box',
                  opacity: loading ? 0.6 : 1,
                }}
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{
                ...styles.button,
                opacity: loading ? 0.6 : 1,
                cursor: loading ? 'not-allowed' : 'pointer',
              }}
              onMouseEnter={(e) => {
                if (!loading) {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = `0 6px 20px ${COLORS.primary}40`;
                }
              }}
              onMouseLeave={(e) => {
                if (!loading) {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = `0 4px 12px ${COLORS.primary}30`;
                }
              }}
            >
              {loading ? 'Sending...' : 'Send Message'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
